import { ReactNode } from 'react';
import styled from 'styled-components';

interface InnerProps {
  children: ReactNode;
  className?: string;
}

const Wrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  // max-width: 1200px;
`;

function Inner({ children, className }: InnerProps): React.ReactElement {
  return <Wrapper className={className}>{children}</Wrapper>;
}

export default Inner;
